import UserRole from "../../../../../../common/types/user-role";
import UserPermissions from "../../../../../../common/utils/user/permissions/user-permissions";
import UserPermissionsDefinition from "../../../../../../common/utils/user/permissions/user-permissions-definition";

export type BillingsCargoOrderListingUserPermissionOption =
  | "hasAccessToCargoView"
  | "hasAccessToRailyView"
  | "hasAccessToEditCargoWithTaxiBilling"
  | "hasAccessToDetailsCargoWithTaxiBilling";

export type BillingsCargoOrderListingUserPermissionsDefinition =
  UserPermissionsDefinition<BillingsCargoOrderListingUserPermissionOption>;

export type BillingsCargoOrderListingUserPermissions =
  UserPermissions<BillingsCargoOrderListingUserPermissionOption>;

const billingsCargoOrderListingUserPermissionDefinition: BillingsCargoOrderListingUserPermissionsDefinition =
  {
    hasAccessToCargoView: [UserRole.CARGO_OFFICER],
    hasAccessToRailyView: [UserRole.ADMIN],
    hasAccessToEditCargoWithTaxiBilling: [UserRole.ADMIN],
    hasAccessToDetailsCargoWithTaxiBilling: [
      UserRole.ADMIN,
      UserRole.CARGO_OFFICER,
    ],
  };

export default billingsCargoOrderListingUserPermissionDefinition;
